/**
 * Sticky Navigation
 */

// Utilities
import debug from "debug";
import plugin from '../../lib/plugin';
const MODULE_NAME = 'core/modules/location-change';
const log = debug(MODULE_NAME);

const validationMessages = {
    connection:
        $(`meta[name="site.locationChangePlugin.connection"]`).attr(
            'content'
        ) ||
        'An error occurred sending your request to the server. Please try again later.',
    setLocation:
        $(`meta[name="site.locationChangePlugin.setLocation"]`).attr(
            'content'
        ) ||
        'An error occurred setting your location. Please try again later.',
};

const PROGRESS_CLASS = 'has-progress';
const FORM_WRAPPER_SELECTOR = 'data-form-wrapper-element';


class LocationChangePlugin {

    constructor (element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$wrapperElement = $(this.options.wrapperElement);
        this.$changeLocationElement = $(this.options.changeLocationElement);
        this.$changeFormWrapperElement = $(this.options.changeFormWrapperElement);

        this.$locationSearchElement = this.$element.find(this.options.locationSearchElement);

        this.$formWrapperElement = $(this.$locationSearchElement.attr(FORM_WRAPPER_SELECTOR));
        this.$formSubmitElement = this.$element.find(this.options.formSubmitElement);
        this.$formElement = this.$formWrapperElement.find('form');
        this.$storeSelectElement = this.$element.find(this.options.storeSelectElement);

        this.$storeElement = this.$formWrapperElement.find(this.options.storeElement);
        this.$postcodeElement = this.$formWrapperElement.find(this.options.postcodeElement);
        this.$stateElement = this.$formWrapperElement.find(this.options.stateElement);
        this.$suburbElement = this.$formWrapperElement.find(this.options.suburbElement);
        this.$latitudeElement = this.$formWrapperElement.find(this.options.latitudeElement);
        this.$longitudeElement = this.$formWrapperElement.find(this.options.longitudeElement);

        this.$errorElement = this.$element.find(this.options.errorElement);
        this.errorClassname = this.options.errorClassname;
        this.$defaultElement =  $(this.options.defaultElement);
        log('LocationChangePlugin', element);

        this.watch();

        if (typeof(this.$defaultElement) !== 'undefined' && this.$defaultElement.val() == 'true') {
            this.autoDetectLocation();
        }
    }

    autoDetectLocation() {
        if (navigator.geolocation){
            navigator.geolocation.getCurrentPosition(this.setCurrentLocation.bind(this), this.autoDetectError);
        }
    }

    autoDetectError() {
        // Couldn't detect location. This is ok because the back end has a go too.
    }

     fillInAddress(place, latitude, longitude) {
       	var suburb = '';
        var state = '';
        var postalTown = '';
        var postcode = '';
        var administrative_area_level_2 = '';

        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];
          if (addressType =='postal_code') {
          	postcode =  place.address_components[i]['short_name'];
          }
          if (addressType == 'postal_town') {
            postalTown = place.address_components[i]['short_name'];
          }
          if (addressType == 'locality'|| addressType =='colloquial_area') {
            suburb = place.address_components[i]['long_name'];
          }
          if (addressType == 'administrative_area_level_1') {
            state = place.address_components[i]['short_name'];
          }
          if (addressType == 'administrative_area_level_2') {
            administrative_area_level_2 = place.address_components[i]['short_name'];
          }
        }

        if (suburb.length == 0) {
          suburb = postalTown;
        }
        if (suburb.length == 0) {
          suburb = administrative_area_level_2;
        }

        return  `${this.options.setLocationEndpointUrl}/?latitude=${latitude}&longitude=${longitude}&postcode=${postcode}&state=${state}&suburb=${suburb}`;
    }

    setGeocodeLocation(result, latitude, longitude) {
    	const url = this.fillInAddress(result, latitude, longitude);
        var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
        var module= this;
        log('accepting', this.$element, url);
        $.ajax({
            url,
            method: 'post',
             data: {
                __RequestVerificationToken: token
            },
            success: result => {
                module.$formSubmitElement
                    .removeAttr('disabled');
                module.onSetLocationSuccess(result);
            },
            error: e => {
                log('getStoresAjaxError', e);
                module.$formSubmitElement
                    .removeAttr('disabled');
                module.handleErrors([validationMessages.connection], 'submit');
            }
        }).done(() => {
            log('accepted', module.$element, url);
        });
    }

    setCurrentLocation(position) {
    	if (navigator.geolocation) {
    		const geocoder = new google.maps.Geocoder;
    		var module = this;
    		var options = {
    			'location' : new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
	        };

			geocoder.geocode(options, (results, status) => {
				if (status !== "OK") {
					reject(status);
				}
				if (results.length >= 0) {
					module.setGeocodeLocation(results[0], position.coords.latitude, position.coords.longitude);
				}
			});
    	}
    }

    setLocation () {
        this.$formSubmitElement.addClass(PROGRESS_CLASS).attr('disabled','disabled');
        if (this.formIsValid()) {
            this.$formSubmitElement
            .removeClass(PROGRESS_CLASS)
            .removeAttr('disabled');
        }
    }

    formIsValid() {
        var isValid = true;
        var state = '';

        if (typeof(this.$postcodeElement) !== 'undefined') {
            this.$postcodeElement.parent().find('.field-validation-error').addClass('hide');
        }

        if (typeof(this.$locationSearchElement) == 'undefined' || this.$locationSearchElement.val().length == 0) {
            return false;
        }

        if (typeof(this.$storeElement) !== 'undefined') {
            if (this.$storeElement.val().length == 0) {
                return false;
            }
        }

        if (typeof(this.$stateElement) == 'undefined' || this.$stateElement.val().length == 0) {
            return false;
        }
        else {
            state = this.$stateElement.val();
        }

        if (typeof(this.$postcodeElement) == 'undefined' || this.$postcodeElement.val().length == 0) {
            this.$postcodeElement.addClass('input-validation-error');
            return false;
        }
        else if (this.postcodeIsValid(state, this.$postcodeElement.val()) == false) {
            this.$postcodeElement.addClass('input-validation-error');
            this.$postcodeElement.parent().find('.field-validation-error').removeClass('hide');
            return false;
        }
        return isValid;
    }

    postcodeIsValid(state, postcode) {
        var pcode = parseInt(postcode);
        if (isNaN(pcode)) {
            return false;
        }

        switch (state) {
            case 'NSW':
            case 'nsw':
                return pcode >= 1000 && pcode <= 1999
                || pcode >= 2000 && pcode <= 2599
                || pcode >= 2619 && pcode <= 2899
                || pcode >= 2921 && pcode <= 2999;
            break;
            case 'ACT':
            case 'act':
                return pcode >= 200 && pcode <= 299
                || pcode >= 2600 && pcode <= 2618
                || pcode >= 2900 && pcode <= 2920;
            break;
            case 'VIC':
            case 'vic':
                return pcode >= 3000 && pcode <= 3999
                || pcode >= 8000 && pcode <= 8999;
            break;
            case 'QLD':
            case 'qld':
                return pcode >= 4000 && pcode <= 4999
                || pcode >= 9000 && pcode <= 9999;
            break;
            case 'SA':
            case 'sa':
                return pcode >= 5000 && pcode <= 5999;
            break;
            case 'WA':
            case 'wa':
                return pcode >= 6000 && pcode <= 6799
                || pcode >= 6800 && pcode <= 6999;
            break;
            case 'TAS':
            case 'tas':
                return pcode >= 7000 && pcode <= 7999;
            break;
            case 'NT':
            case 'nt':
                return pcode >= 800 && pcode <= 999;
            break;
        }

        return false;
    }

    handleErrors(errorList, errorSource) {
        const errorMessage = errorList.join(' ');
        const submitErrorClass =
            errorSource == 'submit' ? this.options.submitErrorClassname : '';
        if (this.$errorElement.length > 0) {
            this.$errorElement.empty().append(errorMessage);
        }

        this.$formSubmitElement.addClass(`${this.errorClassname} ${submitErrorClass}`);
    }

    clearErrors() {
        this.$formSubmitElement.removeClass(
            `${this.errorClassname} ${this.options.submitErrorClassname}`
        );
        this.$errorElement.empty();
    }

    resetForm() {
        this.$locationSearchElement.val('').trigger('keyup');
        this.clearErrors();
    }

    showChangeLocationForm() {
        this.$wrapperElement.hide();
        this.$changeFormWrapperElement.removeClass('hide');
    }

    validateReturnedAddress() {
    	var isValid = true;
    	var state = '';
    	this.$postcodeElement.removeClass('input-validation-error');
    	this.$postcodeElement.parent().find('.field-validation-error').addClass('hide');
    	if (this.$stateElement.val().length == 0) {
    		isValid = false;
    		this.$stateElement.closest(this.options.fieldWrapper).removeClass('hide');
    		this.$stateElement.attr('data-user-changed', true);
    	}
    	else {
    		state = this.$stateElement.val();
	    	if (typeof(this.$stateElement.attr('data-user-changed')) == 'undefined') {
	    		this.$stateElement.closest(this.options.fieldWrapper).addClass('hide');
	    	}
    	}

    	if (this.$postcodeElement.val().length == 0 || !this.postcodeIsValid(state, this.$postcodeElement.val())) {
    		isValid = false;
    		this.$postcodeElement.addClass('input-validation-error');
    		this.$postcodeElement.closest(this.options.fieldWrapper).removeClass('hide');
    		this.$postcodeElement.attr('data-user-changed', true);
			this.$postcodeElement.parent().find('.field-validation-error').removeClass('hide');
    	}
    	else if (typeof(this.$postcodeElement.attr('data-user-changed')) == 'undefined') {
    		this.$postcodeElement.closest(this.options.fieldWrapper).addClass('hide');
    	}

    	if (this.$suburbElement.val().length == 0) {
    		isValid = false;
    		this.$suburbElement.closest(this.options.fieldWrapper).removeClass('hide');
    		this.$suburbElement.attr('data-user-changed', true);
    	}
    	else if (typeof(this.$suburbElement.attr('data-user-changed')) == 'undefined') {
    		this.$suburbElement.closest(this.options.fieldWrapper).addClass('hide');
    	}

    	if (isValid) {
    		this.getStores();
    		this.$storeSelectElement.closest(this.options.fieldWrapper).removeClass('hide');
    		this.$formSubmitElement.removeAttr('disabled', 'disabled');
    	}
    	else {
    		this.$storeSelectElement.closest(this.options.fieldWrapper).addClass('hide');
    		this.$formSubmitElement.attr('disabled', 'disabled');
    	}

    	return isValid;
    }

    getStores() {
        const url = `${this.options.endpointUrl}/?latitude=${this.$latitudeElement.val()}
            &longitude=${this.$longitudeElement.val()}&state=${this.$stateElement.val()}`;

        var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();

        this.$storeSelectElement.focus();


        var module= this;
        log('accepting', this.$element, url);
        $.ajax({
            url,
            method: 'post',
             data: {
                __RequestVerificationToken: token
            },
            success: result => {
                module.$formSubmitElement
                    .removeAttr('disabled');
                module.onGetStoresSuccess(result);
            },
            error: e => {
                log('getStoresAjaxError', e);
                module.$formSubmitElement
                    .removeAttr('disabled');
                module.handleErrors([validationMessages.connection], 'submit');
            }
        }).done(() => {
            log('accepted', module.$element, url);
        });
    }

    setLocationScrollPositionCookie(scrollPos) {
    	var cname = this.options.locationScrollPositionCookieName;
    	var cvalue = scrollPos;
    	var d = new Date();
	    d.setTime(d.getTime() + (1*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

	getLocationScrollPositionCookie() {
		var cname = this.options.locationScrollPositionCookieName;
	    var name = cname + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(';');
	    for(var i = 0; i <ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}

	deleteLocationScrollPositionCookie() {
		var cname = this.options.locationScrollPositionCookieName;
		document.cookie = cname+'=; Max-Age=-99999999;';
	}

    onSetLocationSuccess(result) {
         if (typeof result.Success !== 'undefined' && result.Success) {
         	var page_y =  $(window).scrollTop();
         	this.setLocationScrollPositionCookie(page_y);
            location.reload();
        } else {
            var errorList =
                typeof result.ValidationMessages !== 'undefined'
                    ? result.ValidationMessages
                    : Array();
            log('setLocationError', errorList);
            this.handleErrors([validationMessages.setLocation], 'setLocation');
        }
    }

    onGetStoresSuccess(result) {
        if (typeof result.Success !== 'undefined' && result.Success) {
            if (typeof result.Stores !== 'undefined') {
                this.populateStoresList(result.Stores);
            }
        } else {
            var errorList =
                typeof result.ValidationMessages !== 'undefined'
                    ? result.ValidationMessages
                    : Array();
            log('setLocationServerError', errorList);
            this.handleErrors(errorList, 'server');
        }
    }

    populateStoresList(stores) {
        if (typeof(stores) !== 'undefined') {
            this.$storeSelectElement.children('option').remove();
            for(var i=0; i<stores.length;i++){
                 $("<option/>", {
                    "value": stores[i].BranchCode,
                    "text": stores[i].Name
                }).appendTo( this.$storeSelectElement);
            }

            this.setStore();
        }
    }

    setStore() {
        this.$storeElement.val(this.$storeSelectElement.val());
    }

    submitForm() {
    	if (this.formIsValid()) {
        	this.$formElement.submit();
        }
    }

    watch () {
        this.$changeLocationElement.on('click', this.showChangeLocationForm.bind(this));
        this.$storeSelectElement.on('change', this.setStore.bind(this));
        this.$locationSearchElement.on('change', this.setLocation.bind(this));
        this.$formSubmitElement.on('click', this.submitForm.bind(this));
        this.$postcodeElement.on('change', this.validateReturnedAddress.bind(this));
        this.$suburbElement.on('change', this.validateReturnedAddress.bind(this));
        this.$stateElement.on('change', this.validateReturnedAddress.bind(this));

        $( document ).on( 'address-validation-complete', this.validateReturnedAddress.bind(this));
        var module = this;
        window.onload = function () {
        	var cookieVal = module.getLocationScrollPositionCookie();
            if ( cookieVal != -1 ) {
            	module.deleteLocationScrollPositionCookie();
                document.getElementsByTagName("body")[0].scrollTop = cookieVal;
            }
        };
    }

    unwatch () {
        this.$changeLocationElement.on('off', this.showChangeLocationForm.bind(this));
        log('unbound', this.$element);
    }

}

LocationChangePlugin.DEFAULTS = {
    wrapperElement : '.location_details__wrapper',
    changeFormWrapperElement: '.change-location-form',
    changeLocationElement : '.input__change-location',
    locationSearchElement : '.input__location-select',
    storeSelectElement : '.input__store-select',
    formSubmitElement : '.input__location-submit',
    suburbElement : '.input__location-suburb',
    stateElement : '.input__location-state',
    storeElement : '.input__location-store',
    postcodeElement : '.input__location-postcode',
    latitudeElement : '.input__location-latitude',
    longitudeElement : '.input__location-longitude',
    defaultElement : '.input__location-default',
    fieldWrapper: '.input__location-select__wrapper',
    errorElement: '.error-message',
    errorClassname: 'error',
    locationScrollPositionCookieName : 'str001.LocationScrollPosition',
    submitErrorClassname: 'submit-error',
    endpointUrl: $(`meta[name="site.getStoresApiEndpoint"]`).attr('content'),
    setLocationEndpointUrl :$(`meta[name="site.setLocationApiEndpoint"]`).attr('content')
};

plugin('locationChange', LocationChangePlugin);

// Export
export function exec () {
    $(document).ready( () => {
        log('binding');
        $(".change-location-form").locationChange();
        log('bound');
    });
}


// WEBPACK FOOTER //
// ./project/client/src/core/modules/location-change/index.js